import styled, { css } from "styled-components";
import { Link } from 'react-router-dom';
import { Image } from "cloudinary-react";

// IE11 requires a nested flex container for the column to grow correctly.
export const LayoutWrwapper = styled.div`
  display: flex;
`;

export const Layout = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  position: relative;
  z-index: 0;
  flex: 1 0 auto;
`;

export const Header = styled.div`
  a {
    font-size: 2em;
    line-height: 0;
    color: #fff;
    text-decoration: none;
  }
`;

export const Nonprofit = styled.div`
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const Back = styled(Link)`
  display: block;
  margin-left: -20px;
  padding: 15px 20px;

  &:after {
    content: "";
    display: block;
    height: 0;
    width: 0;
    border: 7px solid transparent;
    border-right-color: inherit;
    transform: translate(-20%, 1px) scaleY(0.85);
  }
`;

export const Name = styled.div`
  font-size: 1.5em;
  font-weight: 700;
  padding: 10px 0;

  @media screen and (max-width: 767px) {
    font-size: 1em;
  }
`;
const disablePrinting = css`
  @media print {
    display: none;
  }
`;

export const Heading = styled.div`
  font-size: 1.5em;
  margin-bottom: 10px;
  padding: 10px 0;

  @media screen and (min-width: 768px) {
    font-size: 2em;
    margin-bottom: 20px;
    padding: 20px 0;
  }
`;

export const ThankYou = styled.p`
  font-size: 1.125em;
  font-weight: 500;
  margin-bottom: 20px;
`;

export const LoadingEntryNumbers = styled.p`
  margin-bottom: 20px;
`;

export const EntrySummary = styled.div`
  font-size: 1.25em;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333333;
`;

export const EntryNumbers = styled.div`
  font-size: 1.75em;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333333;
`;

export const Message = styled.p`
  color: #555555;
  margin-bottom: 20px;
  line-height: 1.25em;
`;

export const ShareCTA = styled.p`
  color: #555555;
  margin-bottom: 20px;
  ${disablePrinting}
`;

export const LargeThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    display: none;
  }
  ${disablePrinting}
`;

export const SmallThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (min-width: 481px) {
    display: none;
  }
  ${disablePrinting}
`;

export const LargeSponsorCampaignImage = styled(LargeThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

export const SmallSponsorCampaignImage = styled(SmallThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

export const HiddenAmount = styled.div`
  display: none;
`;
